import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CongestionControlAndQoS = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Congestion Control, Traffic Management, QoS"
    videos={[
      "https://www.youtube.com/embed/Hf05vARjcjE?si=kRSilp4ObPyZwiKh",
      "https://www.youtube.com/embed/SJTHXBugoRk?si=CfJ4tSTA51ctUYLL",
      "https://www.youtube.com/embed/Db-tV8JJ3ZQ?si=sp1F1DCYDISJDDHv",
      "https://www.youtube.com/embed/6Vdlk73Up54?si=0ASnDTHq229xBWGt",
      "https://www.youtube.com/embed/KCTQmtWg82Q?si=y0WnqQF9L9cjr2iO",
      "https://www.youtube.com/embed/dP5c6Kr0WV8?si=MQ5XUaoULvVLEx6s"
    ]}
    takeaways={[]}
    questions={[
      "1) Differentiate closed loop and open loop congestion control by quoting 2 mechanisms from each method.",
      "2) Consider a leaky bucket used to control liquid flow, how many gallons of liquid are left in the bucket if the output rate is 5 gal/min, there is an input burst of 200 gal/min for 12 s, and there is no input for 48s?",
      "3) Analyse and compare how congestion window size is updated after each RTT in slow start using exponential increase approach and congestion avoidance using additive increase approach with neat sketches.",
      "4) Explain the congestion control techniques used to improve the QoS of the computer network.",
      "5) Explicate various traffic shaping algorithms used by the transport layer in ensuring QoS during communication.",
      "6) Elucidate the role of Queuing Mechanisms in Congestion Control.",
      "7) Deliberate some common Congestion Avoidance Mechanisms used in TCP?",
      "8) Explain with necessary diagrams how Transmission Control Protocol (TCP) uses the congestion control to alleviate congestion in the network.",
      "9) (a) Illustrate the Hypertext Transfer Protocol (HTTP) transaction between the client and server and illustrate for the following cases: The client wants to retrieve a document from the server. Use the appropriate method. (i) The client wants to send data to the server. Use the appropriate method. (b) Which transport layer service does HTTP use? Differentiate various connection modes of operation used by HTTP."
    ]}
    exampleVideos={[]}
  />
);
}

export default CongestionControlAndQoS;
